
import { Suspense, lazy } from 'react';
import Header from '@/components/Header';
import HeroSection from '@/components/HeroSection';
import ErrorBoundary from '@/components/ErrorBoundary';

// Lazy load heavy components for better performance
const TestimonialsSection = lazy(() => import('@/components/TestimonialsSection'));
const HomeBenefitsSection = lazy(() => import('@/components/HomeBenefitsSection'));
const ProductsSection = lazy(() => import('@/components/ProductsSection'));
const TeachersSection = lazy(() => import('@/components/TeachersSection'));
const FAQSection = lazy(() => import('@/components/FAQSection'));
const Footer = lazy(() => import('@/components/Footer'));
const WhatsAppButton = lazy(() => import('@/components/WhatsAppButton'));

const Index = () => {
  return (
    <div className="min-h-screen bg-slate-900">
      <Header />
      <main>
        <section id="hero" aria-label="Sistemas de Trading Automatizado QuantMake">
          <HeroSection />
        </section>
        <ErrorBoundary>
          <Suspense fallback={<div className="h-20 bg-slate-800/50 animate-pulse" />}>
            <section id="testimonials" aria-label="Resultados Reais dos Robôs Trader">
              <TestimonialsSection />
            </section>
          </Suspense>
        </ErrorBoundary>
        <ErrorBoundary>
          <Suspense fallback={<div className="h-20 bg-slate-800/50 animate-pulse" />}>
            <section id="benefits" aria-label="Como Funciona o Trading Automatizado">
              <HomeBenefitsSection />
            </section>
          </Suspense>
        </ErrorBoundary>
        <ErrorBoundary>
          <Suspense fallback={<div className="h-20 bg-slate-800/50 animate-pulse" />}>
            <section id="products" aria-label="Copy Trade e Robôs Trader Disponíveis">
              <ProductsSection />
            </section>
          </Suspense>
        </ErrorBoundary>
        <ErrorBoundary>
          <Suspense fallback={<div className="h-20 bg-slate-800/50 animate-pulse" />}>
            <section id="teachers" aria-label="Equipe de Especialistas em Trading Quantitativo">
              <TeachersSection />
            </section>
          </Suspense>
        </ErrorBoundary>
        <ErrorBoundary>
          <Suspense fallback={<div className="h-20 bg-slate-800/50 animate-pulse" />}>
            <section id="faq" aria-label="Perguntas Frequentes sobre Robôs Trader">
              <FAQSection />
            </section>
          </Suspense>
        </ErrorBoundary>
      </main>
      <ErrorBoundary>
        <Suspense fallback={<div className="h-20 bg-slate-800/50 animate-pulse" />}>
          <Footer />
        </Suspense>
      </ErrorBoundary>
      <ErrorBoundary>
        <Suspense fallback={null}>
          <WhatsAppButton />
        </Suspense>
      </ErrorBoundary>
    </div>
  );
};

export default Index;
